import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export var Statuses;
(function (Statuses) {
    Statuses["ACTIVE"] = "ACTIVE";
    Statuses["EXPIRED"] = "EXPIRED";
    Statuses["SCHEDULED"] = "SCHEDULED";
})(Statuses || (Statuses = {}));
/** Returns comments */ export const getComments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.request === undefined) {
        throw new Error('Missing required body: request');
    }
    const path = '/api/ws-comments/comments/get';
    const pathInternal = '/api/comments/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.request !== undefined) {
        body = params.request;
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getComments.paramsOrder = [{ type: 'body', paramName: 'request' }, { type: 'parameters' }];
/** Create comment */ export const createComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    const path = '/api/ws-comments/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createComment.paramsOrder = [{ type: 'body', paramName: 'comment' }];
/** get comment by id */ export const getCommentById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-comments/comments/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/comments/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCommentById.paramsOrder = [{ type: 'parameters' }];
/** Returns updated comment */ export const updateComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-comments/comments/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/comments/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateComment.paramsOrder = [{ type: 'body', paramName: 'comment' }, { type: 'parameters' }];
/** Deletes selected comment */ export const deleteComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-comments/comments/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/comments/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteComment.paramsOrder = [{ type: 'parameters' }];
export const getCommentsReceivers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.isPublic === undefined) {
        throw new Error('Missing required parameter: isPublic');
    }
    const path = '/api/ws-comments/comments/receivers';
    const pathInternal = '/api/comments/receivers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.commentIds : (params.commentIds ?? queryDefaults?.['commentIds']);
        if (value !== undefined) {
            urlParams.append('commentIds', value.toString());
        }
    }
    if (params.isPublic !== undefined) {
        urlParams.append('isPublic', params.isPublic.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCommentsReceivers.paramsOrder = [{ type: 'parameters' }];
export const getLatestCommentNotifications = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.isPublic === undefined) {
        throw new Error('Missing required parameter: isPublic');
    }
    const path = '/api/ws-comments/comments/with-latest-notifications';
    const pathInternal = '/api/comments/with-latest-notifications';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.commentIds : (params.commentIds ?? queryDefaults?.['commentIds']);
        if (value !== undefined) {
            urlParams.append('commentIds', value.toString());
        }
    }
    if (params.isPublic !== undefined) {
        urlParams.append('isPublic', params.isPublic.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLatestCommentNotifications.paramsOrder = [{ type: 'parameters' }];
export const markComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    if (params.markersForm === undefined) {
        throw new Error('Missing required body: markersForm');
    }
    const path = '/api/ws-comments/comments/{commentId}/mark'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}/mark'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.markersForm !== undefined) {
        body = params.markersForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markComment.paramsOrder = [{ type: 'body', paramName: 'markersForm' }, { type: 'parameters' }];
export const markComments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-comments/comments/mark';
    const pathInternal = '/api/comments/mark';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markComments.paramsOrder = [{ type: 'body', paramName: 'body' }];
export const getCommentCreators = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.commentIds === undefined) {
        throw new Error('Missing required parameter: commentIds');
    }
    const path = '/api/ws-comments/comments/creators';
    const pathInternal = '/api/comments/creators';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.commentIds !== undefined) {
        urlParams.append('commentIds', params.commentIds.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCommentCreators.paramsOrder = [{ type: 'parameters' }];
/** returns a map of total comments by user */ export const getTotalUsersComments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-comments/comments/by-users';
    const pathInternal = '/api/comments/by-users';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTotalUsersComments.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Replace old account id with new one. */ export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-comments/comments/replace-account-id';
    const pathInternal = '/api/comments/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
/** Get paginated active company notifications for current user with search filters */ export const getUserCompanyNotifications = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-comments/company-notifications';
    const pathInternal = '/api/company-notifications';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.search : (params.search ?? queryDefaults?.['search']);
        if (value !== undefined) {
            urlParams.append('search', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.startDateFrom : (params.startDateFrom ?? queryDefaults?.['startDateFrom']);
        if (value !== undefined) {
            urlParams.append('startDateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.startDateTo : (params.startDateTo ?? queryDefaults?.['startDateTo']);
        if (value !== undefined) {
            urlParams.append('startDateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.showRead : (params.showRead ?? queryDefaults?.['showRead']);
        if (value !== undefined) {
            urlParams.append('showRead', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserCompanyNotifications.paramsOrder = [{ type: 'parameters' }];
/** Create new company notification */ export const createCompanyNotification = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-comments/company-notifications';
    const pathInternal = '/api/company-notifications';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyNotification.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get company notification by id for current user */ export const getUserCompanyNotificationById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-comments/company-notifications/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/company-notifications/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserCompanyNotificationById.paramsOrder = [{ type: 'parameters' }];
/** Get company notification by id for admin */ export const getAdminCompanyNotificationById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-comments/company-notifications/{id}/admin'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/company-notifications/{id}/admin'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdminCompanyNotificationById.paramsOrder = [{ type: 'parameters' }];
/** Update company notification */ export const updateCompanyNotification = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-comments/company-notifications/{id}/admin'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/company-notifications/{id}/admin'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyNotification.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Check if current user company has unread notifications */ export const hasUnreadNotifications = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-comments/company-notifications/has-unread';
    const pathInternal = '/api/company-notifications/has-unread';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
hasUnreadNotifications.paramsOrder = [];
/** Mark all active notifications as read for current user */ export const markAllNotificationsAsRead = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-comments/company-notifications/read-all';
    const pathInternal = '/api/company-notifications/read-all';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
markAllNotificationsAsRead.paramsOrder = [];
/** Mark a single notification as read for current user */ export const markNotificationAsRead = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-comments/company-notifications/{id}/read'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/company-notifications/{id}/read'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markNotificationAsRead.paramsOrder = [{ type: 'parameters' }];
/** Make notification inactive by setting startDate and endDate to now */ export const makeNotificationInactive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-comments/company-notifications/{id}/inactive'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/company-notifications/{id}/inactive'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
makeNotificationInactive.paramsOrder = [{ type: 'parameters' }];
/** Update end date of active notification */ export const updateCompanyNotificationEndDate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-comments/company-notifications/{id}/end-date'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/company-notifications/{id}/end-date'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyNotificationEndDate.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get paginated company notifications for admin with status filter */ export const getAdminCompanyNotifications = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-comments/company-notifications/admin';
    const pathInternal = '/api/company-notifications/admin';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.statuses : (params.statuses ?? queryDefaults?.['statuses']);
        if (value !== undefined) {
            urlParams.append('statuses', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.search : (params.search ?? queryDefaults?.['search']);
        if (value !== undefined) {
            urlParams.append('search', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.startDateFrom : (params.startDateFrom ?? queryDefaults?.['startDateFrom']);
        if (value !== undefined) {
            urlParams.append('startDateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.startDateTo : (params.startDateTo ?? queryDefaults?.['startDateTo']);
        if (value !== undefined) {
            urlParams.append('startDateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.creatorIds : (params.creatorIds ?? queryDefaults?.['creatorIds']);
        if (value !== undefined) {
            urlParams.append('creatorIds', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.targetCompanyIds
            : (params.targetCompanyIds ?? queryDefaults?.['targetCompanyIds']);
        if (value !== undefined) {
            urlParams.append('targetCompanyIds', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdminCompanyNotifications.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
